 <template> 
	<div class="window">
        <div class="header"><span v-html="translation.wyniki_rozgrywki"></span>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="congratulation-box mt2x">
                <img src="../assets/fireworks.gif" class="fireworks" />
                <h2>{{ translation.wyniki_rozgrywki }}</h2>
                <div class="big-heart">
                    <svg class="heart-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="fillGradient" x1="0%" y1="100%" x2="0%" y2="0%">
                            <stop offset="0%" style="stop-color:#f32878;stop-opacity:1" />
                            <stop offset="100%" style="stop-color:#f32878;stop-opacity:1" />
                        </linearGradient>
                        
                        <linearGradient id="rainbowGradient" x1="0%" y1="100%" x2="0%" y2="0%">
                            <stop offset="0%" style="stop-color:#ff1493;stop-opacity:1">
                                <animate attributeName="stop-color" values="#f32878" dur="2s" repeatCount="indefinite"/>
                            </stop>
                            <stop offset="50%" style="stop-color:#ff69b4;stop-opacity:1">
                                <animate attributeName="stop-color" values="#f32878" dur="2s" repeatCount="indefinite"/>
                            </stop>
                            <stop offset="100%" style="stop-color:#ff1493;stop-opacity:1">
                                <animate attributeName="stop-color" values="#f32878" dur="2s" repeatCount="indefinite"/>
                            </stop>
                        </linearGradient>
                        
                        <mask id="heartMask" v-html="mask"></mask>
                    </defs>
                
                    <!-- Kontur serca -->
                    <path d="M50,85 C50,85 20,65 20,45 C20,35 27,25 37,25 C43,25 50,30 50,30 C50,30 57,25 63,25 C73,25 80,35 80,45 C80,65 50,85 50,85 Z" 
                        fill="none" 
                        stroke="#ff1493" 
                        stroke-width="2"/>
                    
                    <!-- Wypełnienie serca -->
                    <path d="M50,85 C50,85 20,65 20,45 C20,35 27,25 37,25 C43,25 50,30 50,30 C50,30 57,25 63,25 C73,25 80,35 80,45 C80,65 50,85 50,85 Z" 
                        fill="url(#fillGradient)" 
                        mask="url(#heartMask)" 
                        id="heartFill"/>
                    </svg>
                    <div class="percentage-text" id="percentageText">{{ percentage }}%</div>
                </div>
                <div v-for="index in rows" :key="index">
                    <div class="congratulation-flex">
                    <div class="congratulation-text line2"><span>{{ index.name }}:</span><span>{{ index.score }}%</span></div>
                    <div class="progressbar"><div class="filled" :style="filledScore(index.score)"></div></div>
                </div> 
               
                </div>
            </div>
        </div>

        <div class="to-bottom">
            <button class="btn btn-all btn-return"  @click="returnToCategories" v-html="translation.powrot_do_kategorii"></button>
            <button class="btn btn-all btn-green"  @click="joinGame" v-html="translation.zagraj_ponownie"></button>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'PodsumowaniePoziomu',
    props: {
        language: String
    },
    components: { 
        Cog6ToothIcon,
     
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            percentage: 0,
            mask: '',
            rows: '',
            theme: localStorage.getItem('theme'),
            poprzednia_gra: (
                    (localStorage.getItem('game-hash-confirmed') != null &&
                    localStorage.getItem('game-hash-confirmed') != '' &&
                    localStorage.getItem('game-hash-confirmed').length >10)?true:false),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }

        let summary_percent=0, 
            summary_rows=0, 
            temp='', 
            three = 0,
            nazwa = '',
            rows = new Array();
        for(let level=1; level<=6; level++) {
            three = 0;
            for(let subl = 1; subl <= 3; subl++) {
                temp = JSON.parse(localStorage.getItem('levels-'+level+'-'+subl));
                summary_rows++;
                summary_percent+= temp.wynik;
                three += temp.wynik;
                nazwa = temp.name;
            }
            rows.push(( { 'name': this.translation[nazwa], 'score': Math.ceil(three/3) } ));
        }
        this.percentage = Math.ceil(summary_percent/summary_rows);
        this.rows = rows;
    },
    mounted() {
        this.mask = '<rect width="100" height="100" fill="black"/><rect x="0" y="'+(29+(100 - this.percentage)/2)+'" width="100" height="'+this.percentage+'" fill="white" class="fill-animation"/>';
    },
    methods: {
        filledScore(val) {
            return ' width: '+val+'% ';
        },
        joinGame() {
            console.log('przekierowuje emit')
            this.$emit('go-nowa-gra');
        },
        openSettings() {
            this.$emit('open-settings');
        },

        returnToCategories() {
            this.$emit('go-to-poziomy');
        },
        returnToAnswers() {
            this.$emit('go-to-nasze-odpowiedzi');
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
h2 {
    text-align:center;
    margin:0;
    padding:0;
    text-transform: uppercase;
}
.fireworks {
    position: absolute;
    width: 100%;
    height: 80vw;
    z-index: 200;
    top: 0;
    left: 0;
}
.gold {
    text-transform:uppercase;
    color: var(--bs-gold);
    letter-spacing: 1.5px;
    font-size: 1.7em;
    margin-top:80px;
}
.to-bottom {
    position: fixed;
    left:0;
    right:0;
    bottom:10px;
    padding: 0 20px;
}
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}
a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}
a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 130px;
    overflow: auto;
}
.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

.btn-gold {
    background-color: var(--bs-gold);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-gold::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    transition: transform 0.3s ease;
}


.btn-return {
    background-color: transparent;
    border:1px solid var(--bs-button-text);
    color: var(--bs-button-text);
    position: relative;
    border-color:var(--bs-button-text);
}
.btn-return::after {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-button-text);
    border-bottom: 2px solid var(--bs-button-text);
    transform: translateY(-50%) rotate(135deg);
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}
.mt2x {
    margin: 2em 0 0.5em;
}
.congratulation-box {
    background: var(--bs-box-background);
    border: var(--bs-settings-button-border);
    border-radius: 8px;
    padding: 20px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

}
/*
.congratulation-box::before {
    content: '🏆';
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(15deg);
}
.congratulation-box::after {
    content: '🏆';
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(-15deg);
}
    */
.congratulation-text {
    position: relative;
    z-index: 1;
    color: var(--bs-settings-button-color-active);
    line-height: 1.5;
    margin: 0;
}
.congratulation-text.line1 {
    font-weight: 600;
    color:var(--bs-button-text);
    display:block;
    text-align:left;
    border-bottom:1px solid var(--bs-button-text);
    margin-bottom:2em;
}

.congratulation-text.line2 {
    color:var(--bs-button-text);
    display:block;
    text-align:left;
    border-bottom:1px solid #aaa;
}
.line2 {
    display: flex !important;
    padding: 5px 0 3px;
    
}
.line2 span:first-child {
  margin-right: auto;
}

.line2 span:last-child {
  white-space: nowrap;
}


.progressbar {
    height: 3px;
    position: relative;    margin-bottom:0.5em;

}

.progressbar .filled {
    background-color: var(--bs-gold);
    height:100%;
    position:absolute;
    left:0;
    top:0;
    bottom:0;
}

.big-heart {
            position: relative;
            display: inline-block;
            margin: 0;
        }

        .heart-svg {
            width: 80vw;
            height: 80vw;
            filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.3));
            animation: pulse 3s ease-in-out infinite;
        }

        .percentage-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 28px;
            font-weight: bold;
            z-index: 10;
            pointer-events: none;
            color: var(--text-color);
            text-shadow: var(--text-shadow);
        }
</style>
